import React, {
    useState,
    useEffect
} from 'react';
import './LibraryList.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function AddLibrary() {
    const [libraryName, setLibraryName] = useState('');
    const [libraryCode, setLibraryCode] = useState('');
    const [selectedEmployeeAuthorization, setSelectedEmployeeAuthorization] = useState('');
    const [employeeAuthorizationList, setEmployeeAuthorizationList] = useState([]);
    const [libraries, setLibraries] = useState([]);
    const [loadingLibraries, setLoadingLibraries] = useState(true);
    const [errorLibraries, setErrorLibraries] = useState('');
    const [entriesToShowLibraries, setEntriesToShowLibraries] = useState(10);
    const [searchQueryLibraries, setSearchQueryLibraries] = useState('');

    // States for managing the modals
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedLibrary, setSelectedLibrary] = useState(null);

    // State for managing the message modal
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('success');

    const fetchLibraries = async () => {
        setLoadingLibraries(true);
        setErrorLibraries('');

        try {
            const response = await fetch(Constants.API_PATH + '/add_new_library_data');
            if (!response.ok) {
                throw new Error(`Failed to fetch libraries: ${response.status}`);
            }
            const data = await response.json();
            setLibraries(data);
        } catch (error) {
            console.error('Error fetching libraries:', error);
            setErrorLibraries('Failed to fetch libraries. Please check the console for details.');
        } finally {
            setLoadingLibraries(false);
        }
    };

    useEffect(() => {
        const fetchEmployeeAuthorization = async () => {
            try {
                const response = await fetch(Constants.API_PATH + '/auth_librarian_list');
                const data = await response.json();
                setEmployeeAuthorizationList(data);
            } catch (error) {
                console.error('Error fetching employees:', error);
            }
        };

        fetchEmployeeAuthorization();
        fetchLibraries();
    }, []);

    const openEditModal = (library) => {
        setSelectedLibrary(library);
        setLibraryName(library.library_name);
        setLibraryCode(library.library_code);
        setSelectedEmployeeAuthorization(library.employee_id);
        setShowEditModal(true); // 🔁 Opens modal
    };
    

    // Handle the edit form submission
    const handleEditLibrarySubmit = async (e) => {
        e.preventDefault();
        console.log(selectedLibrary);
        try {
            const response = await fetch(`${Constants.API_PATH}/update_Library_book_type/${selectedLibrary.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    library_name: libraryName,
                    library_code: libraryCode,
                    employee_authorization_list_id: selectedEmployeeAuthorization,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to update library: ${response.status}`);
            }

            showMessage('Library updated successfully!', 'success');

            // Close the edit modal and reload libraries
            setShowEditModal(false);
            fetchLibraries();
        } catch (error) {
            console.error('Error updating library:', error);
            showMessage('Failed to update library. Please check the console for details.', 'error');
        }
    };

    const handleAddLibrarySubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(Constants.API_PATH + '/add_library_book_type', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    library_name: libraryName,
                    library_code: libraryCode,
                    employee_authorization_list_id: selectedEmployeeAuthorization,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to add library: ${response.status}`);
            }

            showMessage('Library added successfully!', 'success');
            // Reset form fields and close modal
            setLibraryName('');
            setLibraryCode('');
            setSelectedEmployeeAuthorization('');
            setShowAddModal(false);
            fetchLibraries();
        } catch (error) {
            console.error('Error adding library:', error);
            showMessage('Failed to add library. Please check the console for details.', 'error');
        }
    };

    const showMessage = (message, type = 'success') => {
        setMessage(message);
        setMessageType(type);
        setShowMessageModal(true);
    };

    // Function to hide the message modal
    const hideMessage = () => {
        setShowMessageModal(false);
    };

    

    // Delete operation in handleDeleteLibrary method
    const handleDeleteLibrary = async (libraryId) => {
        console.log("Deleting library ID:", libraryId);
        const confirm = window.confirm("Are you sure you want to delete this library?");
        if (!confirm) return;
        try {
            const response = await fetch(`${Constants.API_PATH}/delete_library/${libraryId}`, {
                method: 'DELETE',
            });
    
            if (!response.ok) {
                throw new Error(`Failed to delete library: ${response.status}`);
            }
    
            showMessage('Library deleted successfully!', 'success');
            
            // ✅ Correctly remove the deleted library from UI
            setLibraries((prev) => prev.filter((library) => library.id !== libraryId));
        } catch (error) {
            console.error('Error deleting library:', error);
            showMessage('Failed to delete library. Please check the console for details.', 'error');
        }
    };
    

    const handleEntriesChangeLibraries = (e) => {
        setEntriesToShowLibraries(e.target.value);
    };

    const handleSearchChangeLibraries = (e) => {
        setSearchQueryLibraries(e.target.value);
    };

    // Edit operation in handleEditLibrary method
    const handleEditLibrary = (library) => {
        setLibraryName(library.library_name);
        setLibraryCode(library.library_code);
        setSelectedEmployeeAuthorization(library.employee_id);
    };

    return (
        <div className="add-library-section containernew">
            {/* <nav className="breadcrumb">
                <a href="#" className="breadcrumb-link">Home</a> /
                <a href="#" className="breadcrumb-link">Library Management</a> /
                <span className="breadcrumb-current">Library List</span>
            </nav> */}
    
            <h2 className="section-title">Library List</h2>
    
           
    
            <div className="library-list-section">
                <div className="filters">
                    {/* <div className="entries ">
                      
                        <select value={entriesToShowLibraries} onChange={handleEntriesChangeLibraries} className="form-select showselect">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                      
                    </div> */}
                    <div className="search" >
                        {/* <span style={{margin:"auto"}}>Search:</span> */}
                        <input
                            type="text"
                            value={searchQueryLibraries}
                            onChange={handleSearchChangeLibraries}
                            className="form-input w-70"
                            placeholder="Search"
                          
                        />
                    </div>
                    <div className="" style={{marginTop:"13px"}}>
                         <button className="add-library-button" onClick={() => setShowAddModal(true)}>
                Add New Library
            </button>
                    </div>
                </div>
    
                <div className="table-responsive">
                    {loadingLibraries ? (
                        <p>Loading Libraries Data...</p>
                    ) : errorLibraries ? (
                        <p>{errorLibraries}</p>
                    ) : (
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Library Name</th>
                                    <th>Library Code</th>
                                    {/* <th>Library Name</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {libraries.length === 0 ? (
                                    <tr>
                                        <td colSpan="4">No data available in table</td>
                                    </tr>
                                ) : (
                                    libraries.map((library, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{library.library_name}</td>
                                            <td>{library.library_code}</td>
                                            {/* <td>{library.first_name} {library.last_name}</td> */}
                                            <td>
                                                <button className="custom-table-green" onClick={() => openEditModal(library)}>Edit</button>
                                                
                                                <button className="custom-table-red" onClick={() => handleDeleteLibrary(library.id)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
    
                <div className=" row"> 
                    <div className="col-md-6 pagination">
                    <button disabled style={{width: "35%",textAlign:"center"}}>Previous</button>
                    <button style={{width: "35%",textAlign:"center"}}>Next</button>
                    </div>
                    <div className="col-md-6">
                        <SearchableSelect
                            value={entriesToShowLibraries}
                            onChange={handleEntriesChangeLibraries}
                            options={[
                                { value: 10, label: '10' },
                                { value: 25, label: '25' },
                                { value: 50, label: '50' },
                                { value: 100, label: '100' }
                            ]}
                            clearable={false}
                        />
                    </div>
                </div>
            </div>
    {/* ADD MODAL */}
{showAddModal && (
  <div className="modal show">
    <div className="modal-content">
      <span className="close" onClick={() => setShowAddModal(false)}>&times;</span>
      <h2>Add New Library</h2>
      <form onSubmit={handleAddLibrarySubmit}>
        <label>Library Name:</label>
        <input
          type="text"
          value={libraryName}
          onChange={(e) => setLibraryName(e.target.value)}
          required
        />
        <label>Library Code:</label>
        <input
          type="text"
          value={libraryCode}
          onChange={(e) => setLibraryCode(e.target.value)}
          required
        />
        <label>Employee Authorization:</label>
        <SearchableSelect
          value={selectedEmployeeAuthorization}
          onChange={(e) => setSelectedEmployeeAuthorization(e.target.value)}
          options={employeeAuthorizationList.map((employee) => ({ value: employee.id, label: employee.first_name }))}
          placeholder="Select Employee"
        />
        <button type="submit">Submit</button>
      </form>
    </div>
  </div>
)}

{/* EDIT MODAL */}
{showEditModal && (
  <div className="modal show">
    <div className="modal-content">
      <span className="close" onClick={() => setShowEditModal(false)}>&times;</span>
      <h2>Edit Library</h2>
      <form onSubmit={handleEditLibrarySubmit}>
        <label>Library Name:</label>
        <input
          type="text"
          value={libraryName}
          onChange={(e) => setLibraryName(e.target.value)}
          required
        />
        <label>Library Code:</label>
        <input
          type="text"
          value={libraryCode}
          onChange={(e) => setLibraryCode(e.target.value)}
          required
        />
        <label>Employee Authorization:</label>
        <SearchableSelect
          value={selectedEmployeeAuthorization}
          onChange={(e) => setSelectedEmployeeAuthorization(e.target.value)}
          options={employeeAuthorizationList.map((employee) => ({ value: employee.id, label: `${employee.first_name}${employee.last_name}` }))}
          placeholder="Select Employee"
          required
        />
        <button type="submit">Update</button>
      </form>
    </div>
  </div>
)}

    
         
           
        </div>
    );


}

export default AddLibrary;
